import Vue from 'vue'
import env from '@/lib/env'
import { init } from '@sentry/browser'
import { Vue as VueSentry } from '@sentry/integrations'

const SENTRY_DSN = env('SENTRY_DSN')

if (SENTRY_DSN) {
  init({
    dsn: SENTRY_DSN,
    release: env('RELEASE'),
    environment: env('APP_ENV'),
    integrations: [new VueSentry({ Vue, attachProps: true })]
  })
}



// WEBPACK FOOTER //
// ./src/plugins/sentry.js